import type { ResourceProps } from 'react-admin';
import Inventory2Icon from '@mui/icons-material/Inventory2';

import InventoryItemList from './InventoryItemList';

const inventoryItemsResource: Omit<ResourceProps, 'children'> = {
  name: 'inventory-items',
  list: InventoryItemList,
  icon: Inventory2Icon,
  options: { label: 'Inventory' },
};

export default inventoryItemsResource;
export { inventoryItemsDataProvider } from './dataProvider';
export type { InventoryItemRecord } from './types';
